import { render, staticRenderFns } from "./ProposalEditForm.vue?vue&type=template&id=36526c3a&"
import script from "./ProposalEditForm.vue?vue&type=script&lang=js&"
export * from "./ProposalEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports